import React from 'react';
import Text from 'relements/build/esm/input/text';
import ButtonV2 from '@src/components/ButtonV2';

import TextLabel from '@src/components/TextLabel';

import { createAlert } from '@src/actions/BotActions';
import { AlertTypes } from '@src/constants/MogamboConstants';

import styles from './CreateSkillset.scss';

const CreateSkillset = (props) => {
  const [skillSetName, setSkillSetName] = React.useState('');
  const { skillsetData } = props;

  const skillsetNameCheck = React.useCallback(
    (skillName) => {
      let isUnique = true;
      skillsetData.forEach((item) => {
        const name = item.columns[0].title.toLowerCase();
        if (skillName === name) {
          isUnique = false;
        }
      });
      return isUnique;
    },
    [skillsetData]
  );

  const validateSkillSetName = React.useCallback(
    (value) => {
      const skillName = value.toLowerCase();
      const validateObj = {
        error: false,
        msg: '',
      };

      if (!skillName || skillName.trim().length === 0) {
        validateObj.error = true;
        validateObj.msg = 'Skill Set name must not be empty.';
      } else if (!/^[a-z0-9 ]+$/.test(skillName)) {
        validateObj.error = true;
        validateObj.msg = 'Skill Set name must not have special characters.';
      } else if (!skillsetNameCheck(skillName)) {
        validateObj.error = true;
        validateObj.msg = 'Skill Set name must be unique.';
      }

      return validateObj;
    },
    [skillsetNameCheck]
  );

  const createNewSkillSet = React.useCallback(() => {
    const validateData = validateSkillSetName(skillSetName);

    if (validateData.error) {
      negativeAlert(validateData.msg);
      return;
    }

    props.onCreate(skillSetName);
  }, [negativeAlert, props, skillSetName, validateSkillSetName]);

  const handleInputChange = React.useCallback((value) => {
    setSkillSetName(value);
  }, []);

  const negativeAlert = React.useCallback((msg) => {
    createAlert(msg, undefined, AlertTypes.NEGATIVE);
  }, []);

  return (
    <div className={styles.CreateSkillset}>
      <TextLabel value="Skill Set Name" />
      <Text
        placeholder="Write here..."
        className={styles.CreateSkillsetInput}
        prefixClassName="CreateSkillsetInput"
        value={skillSetName}
        onChange={handleInputChange}
      />
      <div className={styles.CreateSkillsetFooter}>
        <ButtonV2
          onClick={createNewSkillSet}
          disabled={skillSetName.trim().length === 0}
        >
          Create
        </ButtonV2>
      </div>
    </div>
  );
};

export default CreateSkillset;
